<template>
  <v-autocomplete
    color="primary"
    v-model="requestsSelected"
    :clearable="!unclearable"
    :items="Items"
    :loading="loading"
    :search-input.sync="requestsSearch"
    item-text="Description"
    item-value="id"
    item-disabled="disabled"
    return-object
    :single-line="dense"
    :dense="dense"
    :hide-details="dense"
    :hint="hint"
    :style="dense ? 'margin-left: auto; margin-right: auto' : ''"
  >
    <template v-if="errorHint" v-slot:message="{ key, message }">
      <div :class="key == 0 ? 'danger--text' : ''">
        {{ message }}
      </div>
    </template>
  </v-autocomplete>
</template>

<script>
import { mapState } from "vuex";
import i18n from "@/i18n";
import Standard from "@/api/standard_requests";

export default {
  name: "SearcherStandardRequest",

  props: {
    value: Object,
    noLabel: Boolean,
    dense: Boolean,
    unclearable: Boolean,
    disabledItems: Array,
    hint: String,
    errorHint: Boolean,
    refresh: Boolean,
  },

  computed: {
    Items() {
      var request = this.qacenter_standard_requests;

      return request.map((e) => {
        const Description = i18n.t("QacenterStandardRequests.code_title", [
          e.code,
          e.title,
        ]);
        const disabled = this.disabledItems
          ? this.disabledItems.find((disabledItem) => disabledItem.id == e.id)
          : false;
        return Object.assign({}, e, { Description, disabled });
      });
    },
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["settings"]),
  },

  data: () => ({
    qacenter_standard_requests: [],

    loading: false,
    requestsSearch: "",
    requestsSelected: null,
  }),

  mounted() {
    this.getStandardFromAPI();
  },
  methods: {
    getStandardFromAPI() {
      this.loading = true;
      Standard.fetch()
        .then(
          function (response) {
            if (response.data.status.isOK()) {
              this.qacenter_standard_requests =
                response.data.qacenter_standard_requests;
            }
            this.loading = false;
          }.bind(this)
        )
        .catch(
          function () {
            this.loading = false;
          }.bind(this)
        );
    },
  },
  watch: {
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        this.requestsSelected = this.value;
      },
    },
    refresh: {
      deep: true,
      handler() {
        this.getStandardFromAPI();
      },
    },
    requestsSelected: {
      handler() {
        this.$emit("input", this.requestsSelected);
      },
    },
  },
};
</script>
